import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../components/common/style.css';
import '../../components/common/responsive.css';
import './media_sell_now_listing.css';
// import { faCartPlus, faUser, faBars, faTimes, faMapMarkerAlt, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import './sellNowPage.css';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import '../home/homePage.css';
import productImage from '../../assets/images/Frame 20.png';
import { useUser } from '../../contexts/userContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CityPopup from '../../components/common/cityPopup';
import { useCart } from '../../contexts/cartContext';

interface Category {
    cat_id: number;
    title: string;
    parent_cat_id: number | null;
    slug: string;
    parent_title: string;
    children: Category[];
}
interface Product {
    product_id: number;
    cat_id: number;
    title: string;
    base_value: string;
    img_name: string;
    qty: number;
    parent_cat_id: number;
    listing_banner:string;
    slug:string;
  logo_img: string;
  image_alt_tag: string;
}

const generateSessionCode = () => {
    return Math.random().toString(36).substr(2, 9) + Date.now();
};

const SellNowPage: React.FC<{ category?: any }> = ({ category }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [cityName, setCityName] = useState<string | null>(sessionStorage.getItem('cityName') || null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [errorNoCat, setNoCatError] = useState<string | null>(null);
    const [csrfToken, setcsrfToken] = useState<string | null>(null);
    const [categories, setCategories] = useState<Category[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const [isCategoriesVisible, setCategoriesVisible] = useState(false);
    const query = new URLSearchParams(location.search);
    const { city_name,setUtmSessionId ,setSessionCode,setGlobalSearchTerm,utm_session_id,fetchCsrfToken,user_id,sess_code} = useUser();
    const [noProductFound, setNoProductFound] = useState<string | null>(null);
    const [imageLoadingStates, setImageLoadingStates] = useState<{ [key: number]: boolean }>(
      {}
    );
    const {
      setcityName,
      checkSessionTokenExpirationStatus,
      handleRemoveLocalStorage,
      globalUtmQueryRef,
  } = useUser();
    const { fetchCartQuantity,cartQuantity,setCartQuantity,handleQuantity,getBannerOrImageAltTag } = useCart();
    const {globalSearchTerm,setUserId, setUsername } = useUser();
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    const utmSource = query.get('utm_source');
    // const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  const google_api_key = process.env.GOOGLE_API_KEY
  const utmQuery = location.state?.utmQuery || localStorage.getItem("utm_query_data")
  
    let utmQueryRef:any = useRef("")

    

    function generateUtmSessionId(length = 24) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
    
        return result;
    }

  
  const fetchSeoMetaDetails = async () => {
      try {
          const code = 'sell_now'
          const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
            {  method: 'GET',
              headers:{
                // Accept:'aplication/json',
                "Content-Type": "application/json"
        
              },
              credentials: "include",
              mode:"cors"                      
            }
          );
          if (!response.ok) throw new Error('Failed to fetch categories');
          const data = await response.json();
          await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
      } catch (error) {
          //console.error('Error fetching categories:', error);
      }
    };
    
    const changeTitleAndMetaTags = async (
      title: string,
      metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
    ) => {
      try {
          // Update the document title
          if (title) {
              document.title = title;
          } else {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
          }
    
          // Update or create meta tags
          Object.keys(metaTags).forEach((metaName) => {
              const metaTag = document.querySelector(`meta[name="${metaName}"]`);
              if (metaTag) {
                  // Update existing meta tag
                  metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
              } else {
                  // Create new meta tag if it doesn't exist
                  const newMetaTag = document.createElement('meta');
                  newMetaTag.name = metaName;
                  newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                  document.head.appendChild(newMetaTag);
              }
          });
    
          // Cleanup function to reset the title and meta tags when unmounting
          return () => {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
              Object.keys(metaTags).forEach((metaName) => {
                  const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                  if (metaTag) {
                      metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                  }
              });
          };
      } catch (error) {
          //console.error("Error updating title and meta tags:", error);
      }
    };

  useEffect(() => {
    document
    .querySelectorAll(".modal-backdrop")
    .forEach((backdrop) => backdrop.remove());
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
   sessionStorage.removeItem('categoryId');
   sessionStorage.removeItem('productId');
    let GlobalSearchTerm = localStorage.getItem("GlobalSearchTerm");
        setGlobalSearchTerm(GlobalSearchTerm ? GlobalSearchTerm : "");
        fetchSeoMetaDetails()
        
        const code = sessionStorage.getItem('session_code') || generateSessionCode();
        //console.log("session_code",code)
        sessionStorage.setItem('session_code', code);
        setSessionCode(code);
        if (utmSource) {
            // Usage
            const utmSessionId = generateUtmSessionId();// Simple session ID generator
            //console.log("00000000000",utmSessionId,query.toString())
            setUtmSessionId(utmSessionId)
          // query.set('utm_session_id', utmSessionId); // Add utm_session_id to query
          //console.log("query set utm_session_id", query.toString())
          utmQueryRef.current = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(/&/g,":<>:")}`;
          globalUtmQueryRef.current = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
            /&/g,
            ":<>:"
          )}`;
          localStorage.setItem('utm_query_data',`${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(/&/g,":<>:")}`)
          //console.log("query after setting utm_session_id", utmQueryRef.current)
        } else {
          if (utmQuery) {
            //console.log("utm_query set in add to cart", utmQuery);
            utmQueryRef.current = utmQuery;
            globalUtmQueryRef.current = utmQuery
          }
        }

        if (!city_name) {
            setIsPopupVisible(true);
        }

        // Define an async function to generate the cart and then fetch other data
        const initialize = async () => {
            try {
                // Generate cart
                const response = await fetch(`${backendUrl}api/v2/session-cart/${code}`,
                  {  method: 'GET',
                    headers:{
                      // Accept:'aplication/json',
                      "Content-Type": "application/json"
              
                    },
                    credentials: "include",
                    mode:"cors"   
              
                  }
                );
                // Optionally handle response from generateCart here
                // if (!response.ok) {
                //     throw new Error('Failed to generate cart');
                // }

                // Fetch categories and products after cart generation
                const url = window.location.href;
            const commonPart = 'sell-used-appliances?product=';
            const slug = url.split(`${commonPart}`)[1]; 
            if(slug){
              await handleSearch(slug)
            }
                const cat_id = null
                
               
                
                if(slug){
                    await fetchCategoryProducts(slug)
                    // await fetchCategories();
                    // //console.log("--------->>>>>>>>>slug------")
                    // await handleCategorySelect(cat_id)
                }else{
                    // await fetchCategories();
                    //console.log("------------>>>>>>>>jjj",location?.state)
                  
                      await fetchAllCategories();
                      
                  
                      // await fetchProducts();
              }
              // //console.log("GlobalSearchTerm end", GlobalSearchTerm);
              setGlobalSearchTerm(GlobalSearchTerm ? GlobalSearchTerm : "");
              localStorage.removeItem("GlobalSearchTerm");

            } catch (error) {
                //console.error('Error initializing:', error);
                setError('Failed to initialize');
            }
        };
        // Call the async function
        initialize();
    }, []);

    const handleImageLoad = (productId: number) => {
      setImageLoadingStates((prevStates) => ({
        ...prevStates,
        [productId]: false,
      }));
    };
  
    const handleImageError = (productId: number) => {
      setImageLoadingStates((prevStates) => ({
        ...prevStates,
        [productId]: false,
      }));
    };

    const handleSearch = async (slug:any) => {
             
      try {
          const response = await fetch(
              `${backendUrl}api/v2/product/search?title=${slug}`,
              {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json"
                },
                credentials: "include",
                mode:"cors"                            
              }
          );
          const data = await response.json();
          const products = data.data.data;

          if (Array.isArray(products) && products.length > 0) {
              const firstProduct = products[0];
              const catId = firstProduct.cat_id;
              if (window.location.pathname === '/sell-used-appliances') {
                const search ='search'
                        const csrfToken = await fetchCsrfToken();
                          const response = await fetch(
                            `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?search=${search}`,
                            {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                'X-CSRF-Token': csrfToken,
                              },
                              credentials: "include",
                              body: JSON.stringify({
                                searchProduct:slug,
                                
                              }),
                            }
                          );
                setFilteredProducts(data.data.data)
                  // window.location.href = `/sell-used-appliances?product=${slug}`; // Force refresh
              } 

          } else {
              //console.log('No products found');
          }
      } catch (error) {
          //console.error('Error fetching search results:', error);
      }
  }

    const fetchCategories = async () => {
        try {
          
          const response = await fetch(`${backendUrl}${version}product-categories`, 
            {  method: 'GET',
              headers:{
                // Accept:'aplication/json',
                "Content-Type": "application/json"
              },
              credentials: "include",
              mode:"cors"                     
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch categories');
            }
            
            const data = await response.json();
            
            // Check if the data array is empty
                setCategories(data.data);
            
        } catch (error) {
            //console.error('Error fetching categories:', error);
            setError('Failed to load categories');
        }
    };

    const fetchAllCategories= async () => {
      try {
        //console.log("fetch all utmQueryRef",utmQueryRef.current)
        let url = `${backendUrl}${version}product-category?${utmQueryRef.current}`;
        //console.log("query data fetch url",url)
            const response = await fetch(
              url, {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json"
          
                },
                credentials: "include",
                mode:"cors"                            
              }
            );
            if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
            setFilteredProducts(data.data);
        } catch (error) {
            //console.error('Error fetching categories:', error);
            setError('Failed to load categories');
        }
    };

    const fetchCategoryProducts = async (cat_id: any) => {
        // try {
        //     setIsLoading(true);
        //     setFilteredProducts([]); // Clear previous products
        //     setNoProductFound(null);
    
        //     // Adding 2 seconds delay
        //     await new Promise((resolve) => setTimeout(resolve, 1000));
    
        //     const response = await fetch(`${backendUrl}${version}product-cat/${cat_id}`);
        //     if (!response.ok) throw new Error('Failed to fetch category products');
    
        //     const data = await response.json();
        //     if (data.data.length === 0) {
        //         setNoProductFound('No product found.');
        //     } else {
        //         setFilteredProducts(data.data);
        //     }
        // } catch (error) {
        //     //console.error('Error fetching category products:', error);
        //     setError('Failed to load products');
        // } finally {
        //     setGlobalSearchTerm("")
        //     setIsLoading(false);
        // }
    };
    

    const handleViewClick = () => {
        setCategoriesVisible(!isCategoriesVisible);
    };

    const handleSellNowClick = (slug: any) => {
      setGlobalSearchTerm("")
        navigate(`/${slug}`, { state: { slug, utmQuery: utmQueryRef.current } });
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };

    const handleSelectCityClick = () => {
        setIsPopupVisible(true);
    };
    

    const handleDetectLocation = async () => {
      if (!navigator.geolocation) {
          alert('Geolocation is not supported by your browser.');
          return;
      }
  
      // setIsLoading(true); // Start loading spinner
      navigator.geolocation.getCurrentPosition(
          async (position) => {
              const { latitude, longitude } = position.coords;
              const apiKey = 'AIzaSyCO66yKQ63AX-lQmhU7bRUiRkbpGP9nGeU'; // Google Maps API key
  
              try {
                  const responseGoogle = await fetch(
                      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
                  );
                  const data = await responseGoogle.json();
  
                  if (data.status !== 'OK' || !data.results[0]) {
                      throw new Error('Unable to fetch location details.');
                  }
  
                  const addressComponents = data.results[0].address_components;
                  const city = addressComponents.find((component: any) =>
                      component.types.includes('locality') || component.types.includes('administrative_area_level_1')
                  )?.long_name || 'Unknown city';
  
                  const state = addressComponents.find((component: any) =>
                      component.types.includes('administrative_area_level_1')
                  )?.long_name || 'Unknown state';
  
                  const pincode = addressComponents.find((component: any) =>
                      component.types.includes('postal_code')
                  )?.long_name || 'Unknown pincode';
  
                  //console.log('Pincode:', pincode);
  
                  // Fetch city and state data by pincode from backend
                  const pincodeResponse = await fetch(`${backendUrl}api/v2/pincode/${pincode}`,
                    {  method: 'GET',
                      headers:{
                        // Accept:'aplication/json',
                        "Content-Type": "application/json"
                      },
                      credentials: "include",
                      mode:"cors"   
                                                            
                    }
                  );
                  if (pincodeResponse.ok) {
                      const pincodeData = await pincodeResponse.json();
                      if (pincodeData?.data?.city) {
                          const cityName = pincodeData.data.city;
                          const stateName = pincodeData.data.state;
  
                          // Set city and state
                          setcityName(cityName);
                          sessionStorage.setItem('cityName', cityName);
                          sessionStorage.setItem('stateName', stateName);
                          const ipResponse = await fetch("https://api.ipify.org?format=json");
                          const ipData = await ipResponse.json();
                          const ip_address = ipData.ip; // Extract IP
                          if (!ipResponse.ok) {
                              throw new Error("Failed to fetch IP address");
                          }

                          const userId = user_id
                          const csrfToken = await fetchCsrfToken();
                          const saveInfo = await fetch(`${backendUrl}api/v2/location-save?${utmQuery}`, {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                'X-CSRF-Token': csrfToken,
                              },
                              credentials: "include",
                              body:JSON.stringify({pincode:pincode,city:cityName,locality:null,user_id:userId,user_agent:navigator.userAgent,ip_address:ip_address}) ,
                            });
      
                          // Close the popup after successful city detection
                          setIsPopupVisible(false);
                      } else {
                          alert('City data not available for the detected pincode.');
                      }
                  } else {
                      alert('Failed to fetch city data by pincode.');
                  }
              } catch (error) {
                  alert('Failed to fetch location. Please try again.');
              } finally {
                  setIsLoading(false); // Stop loading spinner
              }
          },
          () => {
              alert('Failed to fetch location. Please enable location access.');
              // setIsLoading(false); // Stop loading spinner
          }
      );
  };
  
    
    // useEffect(() => {
      
    //   if (checkSessionTokenExpirationStatus()) {
    //     // alert("Session token expired");
    //     navigate("/");
    //     window.scrollTo({ top: 0, behavior: 'smooth' })
    //     handleQuantity()
    //     handleRemoveLocalStorage()
    //     // window.location.reload();
    //   }
    // }, []);
    useEffect(() => {
      const isSessionHandled = sessionStorage.getItem("sessionHandled");
    
      // If the session was already handled, avoid running this logic again
      if (isSessionHandled) return;
    
      console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
    
      if (checkSessionTokenExpirationStatus()) {
        // Clear session-related operations
        handleQuantity();
        handleRemoveLocalStorage();
    
        // Set the sessionHandled flag to true to prevent re-execution after reload
        sessionStorage.setItem("sessionHandled", "true");
    
        // Redirect to the homepage
        navigate("/");
    
        // Reload the page to clear cache
        window.location.reload();
      }
    }, []);

    return (
      <div>
        <Header
        // onSelectCity={handleSelectCityClick}
        // cityName={cityName || 'Select City'}
        />
        {isPopupVisible && (
          <CityPopup
            onClose={() => setIsPopupVisible(false)}
            onFetchLocation={handleDetectLocation}
            onCitySelected={(cityName) => {
              setCityName(cityName);
              sessionStorage.setItem("cityName", cityName);
            }}
            // setIsLoading={setIsLoading}
          />
        )}

        <div className="section_breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a >Sell Now</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
       
        <section className="sell_now_listing">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
              {isLoading ? (
                                <div className="loader-container">
                                    <div className="loader"></div>
                                </div>
                            ) : noProductFound ? (
                                <p className="no-product">{noProductFound}</p>
                            ) :  (
                  <div className="products_listing_wrap">
                    {filteredProducts.map((product) => (
                      <div key={product.product_id} className="product-card" onClick={() => handleSellNowClick(product?.slug)}>
                        {/* {product?.logo_img ? (
                                <img
                                    src={
                                      product?.logo_img
                                    }
                                    alt="Dynamic Banner"
                                />
                            ) : ( <img
                              src={
                                productImage
                              }
                              alt="Dynamic Banner"
                          />)} */}
                         {imageLoadingStates[product.product_id] !== false && (
                        <div className="image-loader">
                          <div className="spinner"></div>
                        </div>
                      )}
                      <img
                        src={product?.logo_img || productImage}
                        alt={getBannerOrImageAltTag("image",product)}
                        style={{
                          display: imageLoadingStates[product.product_id] === false ? "block" : "none",
                        }}
                        onLoad={() => handleImageLoad(product.product_id)}
                        onError={() => handleImageError(product.product_id)}
                      />
                        
                        {/* <img
                          src={`./${product.listing_banner}`}
                          alt={product.title}
                          onError={(e: any) => {
                            e.target.onerror = null;
                            e.target.src = productImage;
                          }}
                        /> */}
                        <h3>{product.title}</h3>
                        <div className="inside-product-container">
                          <button
                            className="sell-now-button"
                            onClick={() => handleSellNowClick(product?.slug)}
                          >
                            Sell Now
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/* </div> */}
          </div>
        </section>
        <Footer />
      </div>
    );
};

export default SellNowPage;
